import useSWR from 'swr';

import { getSignedUrlByFileId } from '@commenda/utils/files/uploadFile';

/** A short-lived link for reading one stored file. Pass null to skip the request. */
export const useSignedFileUrl = (fileId: number | null) => {
  const { data, error, isLoading, isValidating } = useSWR(
    fileId === null ? null : ['s3/signedUrlForGet', fileId],
    async ([, requestedFileId]: [string, number]) => {
      const signedUrl = await getSignedUrlByFileId(requestedFileId, undefined);
      if (!signedUrl) {
        throw new Error(`Could not sign a link for file ${requestedFileId}`);
      }
      return signedUrl;
    },
    { revalidateOnFocus: false }
  );

  // A cached link may have expired by the time it is shown again, so wait for the fresh one.
  return {
    signedUrl: data ?? null,
    isLoading: isLoading || isValidating,
    error,
  };
};
